import React from 'react';
import { TableHeader, TableRow, TableHead } from '@/components/ui/table';
import SortableTableHeader from '@/components/SortableTableHeader';
import { SortDirection } from '@/components/SortableTableHeader';

interface WorkBehaviorTableHeaderProps {
  sortConfig: {
    key: string | null;
    direction: SortDirection;
  };
  onSort: (key: string) => void;
  isSuperAdmin: boolean;
  selectedIdealProfile: any;
  tableExpanded: boolean;
}

const WorkBehaviorTableHeader: React.FC<WorkBehaviorTableHeaderProps> = ({
  sortConfig,
  onSort,
  isSuperAdmin,
  selectedIdealProfile,
  tableExpanded
}) => {
  // Add debugging
  const handleSort = (key: string) => {
    console.log('WorkBehaviorTableHeader: Sort clicked for key:', key);
    onSort(key);
  };

  return (
    <TableHeader>
      <TableRow className="border-b border-border/60 hover:bg-transparent bg-muted/40">
        <SortableTableHeader 
          sortKey="full_name" 
          currentSortKey={sortConfig.key} 
          currentSortDirection={sortConfig.direction} 
          onSort={handleSort} 
          className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider"
        >
          Name
        </SortableTableHeader>
        
        <SortableTableHeader 
          sortKey="profileType" 
          currentSortKey={sortConfig.key} 
          currentSortDirection={sortConfig.direction} 
          onSort={handleSort} 
          className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider text-center w-24"
        >
          Pattern
        </SortableTableHeader>
        
        <SortableTableHeader 
          sortKey="selfAssessmentComplete" 
          currentSortKey={sortConfig.key} 
          currentSortDirection={sortConfig.direction} 
          onSort={handleSort} 
          className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider text-center w-20"
        >
          Self Chart
        </SortableTableHeader>
        
        <SortableTableHeader 
          sortKey="workAssessmentComplete" 
          currentSortKey={sortConfig.key} 
          currentSortDirection={sortConfig.direction} 
          onSort={handleSort} 
          className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider text-center w-20"
        >
          Work Chart
        </SortableTableHeader>
        
        <SortableTableHeader 
          sortKey="alignment" 
          currentSortKey={sortConfig.key} 
          currentSortDirection={sortConfig.direction} 
          onSort={handleSort} 
          className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider text-center w-20"
        >
          Alignment
        </SortableTableHeader>
        
        <SortableTableHeader 
          sortKey="flagCount" 
          currentSortKey={sortConfig.key} 
          currentSortDirection={sortConfig.direction} 
          onSort={handleSort} 
          className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider text-center w-20"
        >
          Comments
        </SortableTableHeader>
        
        <SortableTableHeader 
          sortKey="cognitivePercentile" 
          currentSortKey={sortConfig.key} 
          currentSortDirection={sortConfig.direction} 
          onSort={handleSort} 
          className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider text-center w-20"
        >
          Cognitive
        </SortableTableHeader>
        
        {selectedIdealProfile && (
          <SortableTableHeader 
            sortKey="matchPercentage" 
            currentSortKey={sortConfig.key} 
            currentSortDirection={sortConfig.direction} 
            onSort={handleSort} 
            className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider text-center w-20"
          >
            Match
          </SortableTableHeader>
        )}

        <TableHead className="h-10 px-4 text-xs font-semibold text-foreground/80 uppercase tracking-wider w-32">
          Actions
        </TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default WorkBehaviorTableHeader;